import { dateFormat } from 'helpers/StringNumberFunction/FormatDate'
import { amtStr, amtStr4Dec } from 'helpers/StringNumberFunction/NumFormatters'
import { toHtmlNewLine } from 'helpers/StringNumberFunction/StringConverter'
import { numberToWords } from 'helpers/stringConverter'

export const ELetterServiceGP = ({
  docType,
  previewDetail,
  allpreviewDetail,
  paramVal,
  ItemIndex,
}) => {
  const creditorDetails = {
    '[SupplierName]': previewDetail?.Supplier?.CompanyName,
    '[SupplierRegNo]': previewDetail?.Supplier?.CompanyRegNo,
    '[SupplierPhoneNo]': previewDetail?.Supplier?.ContactNo,
    '[SupplierAddress]': `${previewDetail?.Supplier?.Address?.address}<br />
          ${
            previewDetail?.Supplier?.Address?.country == 'Singapore'
              ? `${previewDetail?.Supplier?.Address?.country} ${previewDetail?.Supplier?.Address?.postCode}`
              : `${previewDetail?.Supplier?.Address?.postCode} ${previewDetail?.Supplier?.Address?.city}, 
            ${previewDetail?.Supplier?.Address?.state}, ${previewDetail?.Supplier?.Address?.country}`
          }
           <br />`,
    '[SupplierContactName]':
      previewDetail?.Supplier?.CreditorContact[0]?.Name! ?? '',
    '[SupplierContactNo]':
      previewDetail?.Supplier?.CreditorContact[0]?.ContactNo! ?? '',
    '[SupplierContactEmail]':
      previewDetail?.Supplier?.CreditorContact[0]?.Email! ?? '',
    '[SupplierSSTRegNo]': previewDetail?.Supplier?.SSTRegNo! ?? '',
    '[SupplierGSTRegNo]': previewDetail?.Supplier?.GSTRegNo! ?? '',
  }

  switch (docType) {
    case 'direct-po':
      return Object.assign(paramVal, creditorDetails, {
        // Right Header Info
        '[DocumentNo]': previewDetail?.DocNo!,
        '[DocumentDate]': dateFormat(previewDetail?.DocDate!),
        '[Description]': previewDetail?.Description!,
        '[CreditTerm]': previewDetail?.CreditTerm!,
        '[DeliveryDate]': dateFormat(previewDetail?.ExpectedDate!),
        '[SpecialInstruction]': previewDetail?.Instruction!,
        '[Description]': previewDetail?.Description!,
        '[ContactPerson]': previewDetail?.ContactPerson?.name!,
        '[ContactNo]': previewDetail?.ContactPerson?.contactNo!,
        '[DeliveryLocation]': previewDetail?.DeliveryLocation?.Name!,
        '[DeliveryAddress]': `${
          previewDetail?.DeliveryLocation?.Address?.address
        }<br />
          ${
            previewDetail?.DeliveryLocation?.Address?.country == 'Singapore'
              ? `${previewDetail?.DeliveryLocation?.Address?.country} ${previewDetail?.DeliveryLocation?.Address?.postCode}`
              : `${previewDetail?.DeliveryLocation?.Address?.postCode} ${previewDetail?.DeliveryLocation?.Address?.city}, 
            ${previewDetail?.DeliveryLocation?.Address?.state}, ${previewDetail?.DeliveryLocation?.Address?.country}`
          }
           <br />`,

        // Item Info
        items: previewDetail?.itemList?.map((el, i) => {
          return {
            '[Index]': el?.index ?? i,
            '[ItemDescription]': el?.ItemDescription!
              ? toHtmlNewLine(el?.ItemDescription)
              : '',
            '[ItemRemark]': el?.ItemRemark!
              ? toHtmlNewLine(el?.ItemRemark)
              : '',
            '[ItemTaxExemptionReason]': el?.TaxExemptionReason! ?? '',
            '[Department]': el?.Department,
            '[DeptCd]': el?.DeptCd,
            '[DeptCtNm]': el?.DeptCtNm,
            '[DeptCtCd]': el?.DeptCtCd,
            '[UOM]': el?.UOM,
            '[Quantity]': amtStr4Dec(el?.Quantity),
            '[UnitPrice]': amtStr4Dec(el?.UnitPrice),
            '[BaseAmt]': amtStr(el?.BaseAmt),
            '[TaxAmt]': amtStr(el?.TaxAmt),
            '[TotalAmt]': amtStr(el?.TotalAmt),
            '[TaxCode]': el?.ItemTaxInfo?.[0]?.taxInfo?.code! ?? '',
            '[TaxRate]':
              el?.ItemTaxInfo?.[0]?.taxRate !== null ||
              el?.ItemTaxInfo?.[0]?.taxRate !== undefined
                ? el?.ItemTaxInfo?.[0]?.taxRate!
                : '',
            '[PRDocNo]': el?.PRItem?.PRHeader?.DocNo!,
            '[PRRequestedBy]': el?.PRItem?.PRHeader?.RequestedBy!,
          }
        }),
        '[SumBaseAmt]': amtStr(
          allpreviewDetail?.itemList?.reduce(
            (a, b) => a + Number(b?.BaseAmt!),
            0
          )
        ),
        '[SumTaxAmt]': amtStr(
          allpreviewDetail?.itemList?.reduce(
            (a, b) => a + Number(b?.TaxAmt!),
            0
          )
        ),
        '[SumTotalAmt]': amtStr(
          allpreviewDetail?.itemList?.reduce(
            (a, b) => a + Number(b?.TotalAmt!),
            0
          )
        ),
        '[SumTotalAmtWords]': numberToWords(
          allpreviewDetail?.itemList?.reduce(
            (a, b) => a + Number(b?.TotalAmt!),
            0
          )
        ),
        // Exempted Tax Summary Info
        exemptedTaxItem: previewDetail?.TaxExemptionInfo?.map(el => {
          return {
            '[ExemptedTaxReason]': el?.taxExemptionReason! ?? '',
            '[ExemptedTaxCode]': el?.taxExemptionCode! ?? '',
            '[ExemptedTaxAmount]': amtStr(el?.taxExemptionAmount!) ?? '',
            '[ExemptedTaxRate]': el?.taxExemptionRate! ?? '',
          }
        }),
        '[TotalTaxExemptionAmount]':
          previewDetail?.TaxExemptionInfo?.length > 0
            ? previewDetail?.TaxExemptionInfo?.reduce(
                (a, b) => a + Number(b?.taxExemptionAmount),
                0
              )
            : '',
      })

    case 'generate-po-from-pr':
      return Object.assign(paramVal, creditorDetails, {
        // Right Header Info
        '[DocumentNo]': previewDetail?.DocNo!,
        '[DocumentDate]': dateFormat(previewDetail?.DocDate!),
        '[DeliveryDate]': dateFormat(previewDetail?.ExpectedDate!),
        '[SpecialInstruction]': previewDetail?.Instruction!,
        '[Description]': previewDetail?.Description!,
        '[ContactPerson]': previewDetail?.ContactPerson?.name!,
        '[ContactNo]': previewDetail?.ContactPerson?.contactNo!,
        '[CreditTerm]': previewDetail?.CreditTerm!,
        '[DeliveryLocation]': previewDetail?.DeliveryLocation?.Name!,
        '[DeliveryAddress]': `${
          previewDetail?.DeliveryLocation?.Address?.address
        }<br />
          ${
            previewDetail?.DeliveryLocation?.Address?.country == 'Singapore'
              ? `${previewDetail?.DeliveryLocation?.Address?.country} ${previewDetail?.DeliveryLocation?.Address?.postCode}`
              : `${previewDetail?.DeliveryLocation?.Address?.postCode} ${previewDetail?.DeliveryLocation?.Address?.city}, 
            ${previewDetail?.DeliveryLocation?.Address?.state}, ${previewDetail?.DeliveryLocation?.Address?.country}`
          }
           <br />`,

        // Item Info
        items: previewDetail?.itemList?.map((el, i) => {
          return {
            '[Index]': el?.index ?? i,
            '[ItemPRNo]': el?.PRItem?.PRHeader?.DocNo,
            '[ItemDescription]': el?.Item?.Name!
              ? toHtmlNewLine(el?.Item?.Name)
              : '',
            '[ItemRemark]': el?.Remarks! ? toHtmlNewLine(el?.Remarks) : '',
            '[ItemTaxExemptionReason]': el?.TaxExemptionReason! ?? '',
            '[Department]': el?.CostCentre?.Name,
            '[DeptCd]': el?.CostCentre?.Code,
            '[DeptCtNm]': el?.CostCentre?.FirstCostCentre?.Name,
            '[DeptCtCd]': el?.CostCentre?.FirstCostCentre?.Code,
            '[UOM]': el?.UOM?.Code,
            '[Quantity]': amtStr4Dec(el?.OrderedQty),
            '[UnitPrice]': amtStr4Dec(el?.UnitPrice),
            '[BaseAmt]': amtStr(el?.BaseAmt),
            '[TaxAmt]': amtStr(el?.TaxAmt),
            '[TotalAmt]': amtStr(el?.TotalAmt),
            '[TaxCode]': el?.ItemTaxInfo?.[0]?.taxInfo?.code! ?? '',
            '[TaxRate]':
              el?.ItemTaxInfo?.[0]?.taxRate !== null ||
              el?.ItemTaxInfo?.[0]?.taxRate !== undefined
                ? el?.ItemTaxInfo?.[0]?.taxRate!
                : '',
            '[PRDocNo]': el?.PRItem?.PRHeader?.DocNo!,
            '[PRRequestedBy]': el?.PRItem?.PRHeader?.RequestedBy!,
          }
        }),
        '[SumBaseAmt]': amtStr(
          allpreviewDetail?.itemList?.reduce(
            (a, b) => a + Number(b?.BaseAmt!),
            0
          )
        ),
        '[SumTaxAmt]': amtStr(
          allpreviewDetail?.itemList?.reduce(
            (a, b) => a + Number(b?.TaxAmt!),
            0
          )
        ),
        '[SumTotalAmt]': amtStr(
          allpreviewDetail?.itemList?.reduce(
            (a, b) => a + Number(b?.TotalAmt!),
            0
          )
        ),
        '[SumTotalAmtWords]': numberToWords(
          allpreviewDetail?.itemList?.reduce(
            (a, b) => a + Number(b?.TotalAmt!),
            0
          )
        ),
        // Exempted Tax Summary Info
        exemptedTaxItem: previewDetail?.TaxExemptionInfo?.map(el => {
          return {
            '[ExemptedTaxReason]': el?.taxExemptionReason! ?? '',
            '[ExemptedTaxCode]': el?.taxExemptionCode! ?? '',
            '[ExemptedTaxAmount]': amtStr(el?.taxExemptionAmount!) ?? '',
            '[ExemptedTaxRate]': el?.taxExemptionRate! ?? '',
          }
        }),
        '[TotalTaxExemptionAmount]':
          previewDetail?.TaxExemptionInfo?.length > 0
            ? previewDetail?.TaxExemptionInfo?.reduce(
                (a, b) => a + Number(b?.taxExemptionAmount),
                0
              )
            : '',
      })

    case 'centralised-po':
      return Object.assign(paramVal, creditorDetails, {
        // Right Header Info
        '[DocumentNo]': previewDetail?.DocNo!,
        '[DocumentDate]': dateFormat(previewDetail?.DocDate!),
        '[CreditTerm]': previewDetail?.CreditTerm!,
        '[DeliveryDate]': dateFormat(previewDetail?.ExpectedDate!),
        '[SpecialInstruction]': previewDetail?.Instruction!,
        '[DeliveryLocation]': previewDetail?.DeliveryLocation?.Name!,
        '[DeliveryAddress]': `${
          previewDetail?.DeliveryLocation?.Address?.address
        }<br />
          ${
            previewDetail?.DeliveryLocation?.Address?.country == 'Singapore'
              ? `${previewDetail?.DeliveryLocation?.Address?.country} ${previewDetail?.DeliveryLocation?.Address?.postCode}`
              : `${previewDetail?.DeliveryLocation?.Address?.postCode} ${previewDetail?.DeliveryLocation?.Address?.city}, 
            ${previewDetail?.DeliveryLocation?.Address?.state}, ${previewDetail?.DeliveryLocation?.Address?.country}`
          }
           <br />`,

        // Item Info
        items: previewDetail?.itemList?.map((el, i) => {
          return {
            '[Index]': el?.index ?? i,
            '[ItemDescription]': el?.Item?.Name!
              ? toHtmlNewLine(el?.Item?.Name)
              : '',
            '[ItemRemark]': el?.Remarks! ? toHtmlNewLine(el?.Remarks) : '',
            '[ItemTaxExemptionReason]': el?.TaxExemptionReason! ?? '',
            '[Department]': el?.CostCentre?.Name,
            '[DeptCd]': el?.CostCentre?.Code,
            '[DeptCtNm]': el?.CostCentre?.FirstCostCentre?.Name,
            '[DeptCtCd]': el?.CostCentre?.FirstCostCentre?.Code,
            '[UOM]': el?.UOM?.Code,
            '[Quantity]': amtStr4Dec(el?.OrderedQty),
            '[UnitPrice]': amtStr4Dec(el?.UnitPrice),
            '[BaseAmt]': amtStr(el?.BaseAmt),
            '[TaxAmt]': amtStr(el?.TaxAmt),
            '[TotalAmt]': amtStr(el?.TotalAmt),
            '[TaxCode]': el?.ItemTaxInfo?.[0]?.taxInfo?.code! ?? '',
            '[TaxRate]':
              el?.ItemTaxInfo?.[0]?.taxRate !== null ||
              el?.ItemTaxInfo?.[0]?.taxRate !== undefined
                ? el?.ItemTaxInfo?.[0]?.taxRate!
                : '',
            '[PRDocNo]': el?.PRItem?.PRHeader?.DocNo!,
            '[PRRequestedBy]': el?.PRItem?.PRHeader?.RequestedBy!,
          }
        }),
        '[SumBaseAmt]': amtStr(
          allpreviewDetail?.itemList?.reduce(
            (a, b) => a + Number(b?.BaseAmt!),
            0
          )
        ),
        '[SumTaxAmt]': amtStr(
          allpreviewDetail?.itemList?.reduce(
            (a, b) => a + Number(b?.TaxAmt!),
            0
          )
        ),
        '[SumTotalAmt]': amtStr(
          allpreviewDetail?.itemList?.reduce(
            (a, b) => a + Number(b?.TotalAmt!),
            0
          )
        ),
        '[SumTotalAmtWords]': numberToWords(
          allpreviewDetail?.itemList?.reduce(
            (a, b) => a + Number(b?.TotalAmt!),
            0
          )
        ),
        // Exempted Tax Summary Info
        exemptedTaxItem: previewDetail?.TaxExemptionInfo?.map(el => {
          return {
            '[ExemptedTaxReason]': el?.taxExemptionReason! ?? '',
            '[ExemptedTaxCode]': el?.taxExemptionCode! ?? '',
            '[ExemptedTaxAmount]': amtStr(el?.taxExemptionAmount!) ?? '',
            '[ExemptedTaxRate]': el?.taxExemptionRate! ?? '',
          }
        }),
        '[TotalTaxExemptionAmount]':
          previewDetail?.TaxExemptionInfo?.length > 0
            ? previewDetail?.TaxExemptionInfo?.reduce(
                (a, b) => a + Number(b?.taxExemptionAmount),
                0
              )
            : '',
      })

    case 'purchase-requisition':
      return Object.assign(paramVal, creditorDetails, {
        // Right Header Info
        '[RequestedBy]': previewDetail?.RequestedBy!,
        '[ContactPerson]': previewDetail?.ContactNo!,
        '[DocumentNo]': previewDetail?.DocNo!,
        '[DocumentDate]': dateFormat(previewDetail?.DocDate!),
        '[DeliveryDate]': dateFormat(previewDetail?.ExpectedDate!),
        '[Justification]': previewDetail?.Instruction!,
        '[DeliveryLocation]': previewDetail?.DeliveryLocation?.Name!,
        '[DeliveryAddress]': `${
          previewDetail?.DeliveryLocation?.Address?.address
        }<br />
          ${
            previewDetail?.DeliveryLocation?.Address?.country == 'Singapore'
              ? `${previewDetail?.DeliveryLocation?.Address?.country} ${previewDetail?.DeliveryLocation?.Address?.postCode}`
              : `${previewDetail?.DeliveryLocation?.Address?.postCode} ${previewDetail?.DeliveryLocation?.Address?.city}, 
            ${previewDetail?.DeliveryLocation?.Address?.state}, ${previewDetail?.DeliveryLocation?.Address?.country}`
          }
           <br />`,

        // Item Info
        items: previewDetail?.itemList?.map((el, i) => {
          return {
            '[Index]': el?.index ?? i,
            '[ItemDescription]': toHtmlNewLine(el?.Item?.Name),
            '[ItemRemark]': el?.Remark! ? toHtmlNewLine(el.Remark) : '',
            '[Department]': el?.CostCentre?.Name,
            '[DeptCd]': el?.CostCentre?.Code,
            '[DeptCtNm]': el?.CostCentre?.FirstCostCentre?.Name,
            '[DeptCtCd]': el?.CostCentre?.FirstCostCentre?.Code,
            '[UOM]': el?.UOM?.Code,
            '[Quantity]': amtStr4Dec(el?.Quantity),
            '[UnitCost]': amtStr4Dec(el?.UnitCost),
            '[TotalUnitCost]': amtStr(el?.TotalUnitCost),
          }
        }),
        '[SumTotalUnitCost]': amtStr(
          allpreviewDetail?.itemList?.reduce(
            (a, b) => a + Number(b?.TotalUnitCost!),
            0
          )
        ),
      })

    case 'delivery-order':
      return Object.assign(paramVal, creditorDetails, {
        // Right Header Info
        '[DocumentNo]': previewDetail?.DocNo!,
        '[DODate]': dateFormat(previewDetail?.DocDate!),
        '[DocumentDate]': dateFormat(previewDetail?.DocDate!),
        '[Description]': previewDetail?.Description!,
        '[DONo]': previewDetail?.DoNo!,
        '[TransactionDate]': dateFormat(previewDetail?.TransactionDate!),
        '[DeliveryLocation]': previewDetail?.DeliveryLocation?.Name!,
        '[DeliveryAddress]': `${
          previewDetail?.DeliveryLocation?.Address?.address
        }<br />
          ${
            previewDetail?.DeliveryLocation?.Address?.country == 'Singapore'
              ? `${previewDetail?.DeliveryLocation?.Address?.country} ${previewDetail?.DeliveryLocation?.Address?.postCode}`
              : `${previewDetail?.DeliveryLocation?.Address?.postCode} ${previewDetail?.DeliveryLocation?.Address?.city}, 
            ${previewDetail?.DeliveryLocation?.Address?.state}, ${previewDetail?.DeliveryLocation?.Address?.country}`
          }
           <br />`,

        // Item Info
        items: previewDetail?.itemList?.map((el, i) => {
          return {
            '[PONo]': !!el?.POItem?.POHeader?.DocNo
              ? el?.POItem?.POHeader?.DocNo!
              : el?.ReplacedGRTNItem?.DOItem?.POItem?.POHeader?.DocNo!,
            '[ItemDescription]': !!el?.POItem?.Item?.Name
              ? toHtmlNewLine(el?.POItem?.Item?.Name)
              : toHtmlNewLine(
                  el?.ReplacedGRTNItem?.DOItem?.POItem?.Item?.Name!
                ),
            '[ItemRemark]': el?.POItem?.Remarks
              ? toHtmlNewLine(el?.POItem?.Remarks)
              : el?.ReplacedGRTNItem?.DOItem?.POItem?.Remarks
              ? toHtmlNewLine(el?.ReplacedGRTNItem?.DOItem?.POItem?.Remarks)
              : '',
            '[Warehouse]': !!el?.POItem?.Item?.IsInventory
              ? el?.POItem?.Warehouse?.Name ?? '-'
              : el?.ReplacedGRTNItem?.DOItem?.POItem?.Item?.IsInventory
              ? el?.ReplacedGRTNItem?.DOItem?.POItem?.Warehouse?.Name
              : '-',
            '[UOM]': el?.POItem?.UOM?.Code
              ? el?.POItem?.UOM?.Code
              : el?.ReplacedGRTNItem?.DOItem?.POItem?.UOM?.Code,
            '[OrderQty]': !!el?.POItem?.OrderedQty
              ? amtStr4Dec(el?.POItem?.OrderedQty)
              : amtStr4Dec(el?.ReplacedGRTNItem?.DOItem?.POItem?.OrderedQty),
            '[ReceivedQty]': amtStr4Dec(el?.AcceptedQty),
            '[ReceivedAmt]': amtStr(el?.AcceptedAmt),
          }
        }),
        '[SumOrderQty]': amtStr(
          allpreviewDetail?.itemList
            ?.flat?.() // make nested list into flat list cuz orderqty data is nested
            ?.reduce(
              (sum, el) => sum + Number(el?.POItem?.OrderedQty ?? 0),
              0
            ) ?? 0
        ),
        '[SumReceivedQty]': amtStr(
          allpreviewDetail?.itemList?.reduce(
            (a, b) => a + Number(b?.AcceptedQty!),
            0
          )
        ),
        '[SumReceivedAmt]': amtStr(
          allpreviewDetail?.itemList?.reduce(
            (a, b) => a + Number(b?.AcceptedAmt!),
            0
          )
        ),
      })

    case 'good-return-note':
      return Object.assign(paramVal, creditorDetails, {
        // Right Header Info
        '[DocumentNo]': previewDetail?.DocNo!,
        '[DocumentDate]': dateFormat(previewDetail?.DocDate!),
        '[Description]': previewDetail?.Description!,
        '[DONo]': previewDetail?.RefNo!,
        '[ReturnLocation]': previewDetail?.DeliveryLocation?.Name!,
        '[ReturnDate]': dateFormat(previewDetail?.TransactionDate!),

        // Item Info
        items: previewDetail?.itemList?.map((el, i) => {
          return {
            '[GRNNo]': el?.DOItem?.DOHeader?.DocNo,
            '[ItemDescription]': toHtmlNewLine(el?.DOItem?.POItem?.Item?.Name),
            '[ItemRemark]': toHtmlNewLine(el?.DOItem?.POItem?.Remarks),
            '[Warehouse]': !!el?.DOItem?.POItem?.Item?.IsInventory
              ? el?.DOItem?.POItem?.Warehouse?.Name
              : '-',
            '[UOM]': el?.DOItem?.POItem?.UOM?.Code,
            '[ReceivedQty]': amtStr4Dec(el?.DOItem?.AcceptedQty),
            '[ReturnedQty]': amtStr4Dec(el?.ReturnedQty),
            '[ReturnedAmt]': amtStr(el?.ReturnedAmt),
            '[Department]': el?.POItem?.CostCentre?.Name,
            '[DeptCd]': el?.POItem?.CostCentre?.Code,
            '[DeptCtNm]': el?.POItem?.CostCentre?.FirstCostCentre?.Name,
            '[DeptCtCd]': el?.POItem?.CostCentre?.FirstCostCentre?.Code,
          }
        }),

        '[SumReceivedQty]': amtStr4Dec(
          allpreviewDetail?.itemList?.reduce(
            (a, b) => a + Number(b?.DOItem?.AcceptedQty!),
            0
          )
        ),
        '[SumReturnedQty]': amtStr4Dec(
          allpreviewDetail?.itemList?.reduce(
            (a, b) => a + Number(b?.ReturnedQty!),
            0
          )
        ),
        '[SumReturnedAmt]': amtStr(
          allpreviewDetail?.itemList?.reduce(
            (a, b) => a + Number(b?.ReturnedAmt!),
            0
          )
        ),
      })
  }
}
